"use client";

import { useEffect } from "react";

import { LanderShell } from "@/components/lander/lander-shell";
import { LanderButton } from "@/components/lander/lander-ui";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Surface it — the boundary shows a friendly page, it doesn't swallow the
    // error. Next logs it, and any global handler (Bugsnag) still sees it.
    console.error(error);
  }, [error]);

  return (
    <LanderShell tagline={false}>
      <div className="flex flex-col items-center gap-2">
        <h1 className="font-clash text-2xl font-bold leading-tight md:text-3xl">
          Something went wrong.
        </h1>
        <p className="text-bnk-text-secondary">
          An unexpected error occurred. Please try again.
        </p>
      </div>
      <div className="flex w-full flex-col gap-3">
        <LanderButton onClick={reset}>Try again</LanderButton>
        <LanderButton href="/" variant="text">
          Back to home
        </LanderButton>
      </div>
    </LanderShell>
  );
}
